import { Component, inject, Input } from '@angular/core';
import { AppConstants } from "@core/constants";
import { TestService } from "@core/services/test/test.service";

@Component({
  selector: 'app-athlete-card-info',
  templateUrl: './athlete-card-info.component.html',
  styleUrls: ['./athlete-card-info.component.scss']
})
export class AthleteCardInfoComponent {
  public testService: TestService = inject(TestService);
  public constant: any = AppConstants;

  @Input() public athleteData: any;
}
